// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-azap","native":"Header_native__TBzUG"};